import OrderItem from '@admin/OrderItem'
import TableEntity from '@ui/TableEntity'
import Filterable from '@ui/Filterable'
import { createOrder } from '@client/utils'
import { Sortable, SortableOptions } from '@ui/Sortable'
import { PaymentPlan } from '@client/PaymentPlan'
import Payment from '@client/Payment'

export const STATUS_PENDING = 1

export const STATUS_CONFIRMED = 2

export const STATUS_CANCELLED = 3

export type OrderStatus =
	| typeof STATUS_PENDING
	| typeof STATUS_CONFIRMED
	| typeof STATUS_CANCELLED

export default class Order implements TableEntity, Filterable, Sortable {
	constructor(
		public id: number,
		public status: number,
		public currency: string,
		public total: number,
		public items: OrderItem[],
		public currency_precision: number = 2,
		public amount_paid: number = 0,
		public payment_plans: PaymentPlan[] = [],
		public payments: Payment[] = [],
		public reference: string = '',
	) {}

	public getStatus = (): string => {
		switch (this.status) {
			case STATUS_PENDING:
				return 'Pending'
			case STATUS_CONFIRMED:
				return 'Confirmed'
			case STATUS_CANCELLED:
				return 'Cancelled'
			default:
				return 'Unknown'
		}
	}

	public getStatusColour = (): string => {
		switch (this.status) {
			case STATUS_PENDING:
				return '#FFA708'
			case STATUS_CONFIRMED:
				return '#39BD00'
			case STATUS_CANCELLED:
				return '#FF6E52'
			default:
				return '#000000'
		}
	}

	public getFilterName = (): string => {
		return 'order'
	}

	public toFilter = () => {
		return {
			status: this.status,
		}
	}

	public reset = (): Filterable => {
		return createOrder()
	}

	public getOptions = (): SortableOptions => {
		return {
			created_at: [
				{ label: 'Oldest', value: 'asc' },
				{ label: 'Newest', value: 'desc' },
			],
		}
	}
}
